import React, {AriaRole, forwardRef, PropsWithChildren} from 'react';
import styled, {css} from 'styled-components';

import {
  buildInteractionIdProps,
  InteractionComponentProps,
} from '../../../../../../libs/shared/core/src/helpers/interaction/interactionHelpers';
import {TimelineVariationsEnum} from '../../../../../../libs/shared/core/src/store/timelineVariations/timelineVariationsTypes';
import {makeSearchIdAttribute} from '../../../../../../srcCommon/inboxes/search/searchAttributesHelpers';

/*
 * Props.
 */

interface MessageViewerBaseProps extends InteractionComponentProps {
  className?: string;
  role?: AriaRole;
  isChatFollowUp?: boolean;
  isSameTypeAsPrevious?: boolean;
  isPopup?: boolean;
  isFirst?: boolean;
  timelineVariation: TimelineVariationsEnum;
  activityId?: number;
}

/*
 * Style.
 */

interface MessageStyleProps {
  $isChatFollowUp: boolean;
  $isSameTypeAsPrevious: boolean;
  $isPopup: boolean;
  $isFirst: boolean;
  $timelineVariation: TimelineVariationsEnum;
}
const StyledMessageDiv = styled.div<MessageStyleProps>`
  display: flex;
  flex-direction: column;

  margin-top: ${(p) => getMarginTop(p)}px;

  ${(p) => addMessageStyles(p.$timelineVariation)}
`;
const addMessageStyles = ($timelineVariation: TimelineVariationsEnum) => {
  if ($timelineVariation === TimelineVariationsEnum.SYNCHRONOUS) {
    return '';
  }

  return css`
    max-width: 100%;
    min-height: 42px;
  `;
};

function getMarginTop(props: MessageStyleProps) {
  if (props.$isPopup) {
    return 0;
  }

  if (props.$isChatFollowUp) {
    return 4;
  }

  if (props.$isSameTypeAsPrevious) {
    return 16;
  }

  if (props.$isFirst) {
    return 3;
  }

  return 16;
}

/*
 * Component.
 */

export const MessageViewerBase = forwardRef<HTMLDivElement, PropsWithChildren<MessageViewerBaseProps>>(
  (props, ref) => (
    <StyledMessageDiv
      className={props.className}
      role={props.role}
      $isChatFollowUp={Boolean(props.isChatFollowUp)}
      $isSameTypeAsPrevious={Boolean(props.isSameTypeAsPrevious)}
      $isPopup={Boolean(props.isPopup)}
      $isFirst={Boolean(props.isFirst)}
      $timelineVariation={props.timelineVariation}
      ref={ref}
      {...buildInteractionIdProps(props.interactionId)}
      {...makeSearchIdAttribute(props.activityId)}
    >
      {props.children}
    </StyledMessageDiv>
  ),
);
